import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import './ContactPage.css';

export default function ContactPage() {
  const [name,     setName]     = useState('');
  const [email,    setEmail]    = useState('');
  const [message,  setMessage]  = useState('');
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [error,    setError]    = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res  = await fetch('/api/contact.php', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ name, email, message, _hp: '' }),
      });
      const data = await res.json();
      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch {
      setError('Could not send message. Please email us directly at support@lottopickle.com.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Seo
        path="/contact"
        title="Contact LottoPickle"
        description="Get in touch with the LottoPickle team for support, billing questions, or feedback."
      />
      <nav className="contact-nav">
        <Link to="/" className="contact-nav-logo">Lotto<span>Pickle</span></Link>
        <Link to="/app" className="contact-nav-back">&larr; Back to app</Link>
      </nav>

      <div className="contact-content">
        <div className="contact-header">
          <h1>Contact us</h1>
          <p>Have a question, bug report, or feedback? We'd love to hear from you.</p>
        </div>

        {success ? (
          <div className="contact-success">
            <div className="contact-success-icon">✓</div>
            <h2>Message sent!</h2>
            <p>Thanks for reaching out. We'll get back to you at <strong>{email}</strong> within 1–2 business days.</p>
            <Link to="/app" className="contact-back-link">Back to app</Link>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-field">
              <label className="contact-label">Name</label>
              <input
                className="contact-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                required
                maxLength={100}
              />
            </div>

            <div className="contact-field">
              <label className="contact-label">Email</label>
              <input
                className="contact-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="contact-field">
              <label className="contact-label">Message</label>
              <textarea
                className="contact-textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tell us what's on your mind…"
                required
                rows={6}
                maxLength={5000}
              />
              <span className="contact-char-count">{message.length} / 5000</span>
            </div>

            {error && <p className="contact-error">{error}</p>}

            <button className="contact-submit" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send message'}
            </button>
          </form>
        )}
      </div>

      <footer className="contact-footer">
        <p>You can also email us directly at <a href="mailto:support@lottopickle.com">support@lottopickle.com</a></p>
      </footer>
    </div>
  );
}
